import './styles.scss';

const RelatedDocumentsList = ({ children }) => {
  return (
    <div className="relatedDocuments__list">
      <label className="list__label">Normas e Desenhos Padrão Relacionados</label>
      <div className="list__itemsWrapper">{children}</div>
    </div>
  );
};

export default RelatedDocumentsList;
